import { z } from 'zod';

export const productDiscountTypeSchema = z.enum(['None', 'Fake', 'Real']);

export type ProductDiscountTypeSchema = z.infer<typeof productDiscountTypeSchema>;
